import(/* webpackMode: "eager" */ "/Users/janithalakshan/Documents/Workspace/in2e-DEV/in2event-front-end/apps/in2event-staff/app/global-error.tsx");
